import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { IPagination } from 'src/app/models/generic';

const FIRST_PAGE: number = 1;

@Component({
  selector: 'app-scroll-pagination',
  templateUrl: './scroll-pagination.component.html',
  styleUrls: ['./scroll-pagination.component.scss']
})
export class ScrollPaginationComponent implements OnChanges {
  @Input() itemsPerSection: number = 50;
  @Input() count!: number;
  @Input() resetKey: number = 0;
  @Input() isModal: boolean = false;
  @Input() minWidth: string = '200';

  @Output() viewMoreTrigger = new EventEmitter<IPagination>();

  section: number = 1;

  constructor() {}

  ngOnChanges(): void {
    this.section = FIRST_PAGE;
  }

  handleViewMore(): void {
    this.viewMoreTrigger.next({
      Skip: this.section * this.itemsPerSection,
      Take: this.itemsPerSection
    });

    this.section += 1;
  }
}
